var router = require('pjax').Router;
var form = require('./form.js');

router.get('broadcast/:any', form);
